class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const btn  = document.querySelector(".l-header__hum");
    const humMenu  = document.querySelector(".humMenu");
    const html  = document.querySelector("html");

    btn.addEventListener("click", () => {
      btn.classList.toggle("is-active");
      humMenu.classList.toggle("is-active");
      html.classList.toggle("is-hidden");
    })
  }
}
